import { Container } from "pixi.js";

import { AbstractNearWin } from "../../../../abstracts/elements/AbstractNearWin";
import { ApocalypseSpineNames } from "../../../assetsLoader/ApocalypseAssetsNames";
import { normalConfig } from "../../../config/ApocalypseConfig";

export class ApocalypseAnticipation extends AbstractNearWin {
    constructor(parent: Container, animationName: string = `animation`) {
        super(
            parent,
            normalConfig.nearWinDuration!,
            ApocalypseSpineNames.ANTICIPATION,
            animationName
        );

        this.mainSpine.scale.set(1);

        this.x = 52;
        this.y = 190;
    }

    protected onShowAnimationStart(): void {
        this.mainSpine.getSpineTween(this.mainSpineAnimationName, true);
        this.parentContainer.addChild(this);
    }
}
